import { MatDialogRef } from '@angular/material';
import { FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
var ProxyApproveDialogComponent = /** @class */ (function () {
    function ProxyApproveDialogComponent(dialogRef, data, fb) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.fb = fb;
        this._subRelease = new Subject();
        this.ParentTypes = [
            { ID: 1, Description: 'Mother', RequiresNote: false },
            { ID: 2, Description: 'Father', RequiresNote: false },
            { ID: 3, Description: 'Guardian', RequiresNote: false },
            { ID: 4, Description: 'Other (Explain)', RequiresNote: true },
        ];
        this.title = data.TitleText || 'Input Requested';
        this.message = data.MessageText || '';
        this.oktext = data.OKText || 'OK';
        this.canceltext = data.CancelText || 'Cancel';
        this.statement = data.Statement || '';
        this.validators = data.Validators || null;
        this.IsDenial = data.IsDenial != null ? data.IsDenial : false;
    }
    Object.defineProperty(ProxyApproveDialogComponent.prototype, "ParentType", {
        get: function () {
            return this.proxyForm.get('ParentType');
        },
        enumerable: true,
        configurable: true
    });
    ProxyApproveDialogComponent.prototype.ngOnDestroy = function () {
        this._subRelease.next();
        this._subRelease.complete();
    };
    ProxyApproveDialogComponent.prototype.ngOnInit = function () {
        var self = this;
        // Set up the form group
        self.proxyForm = self.fb.group({
            Checked: [null, Validators.required],
            ParentName: ['', Validators.required],
            ParentType: [null, Validators.required],
            ParentTypeNote: [''],
        });
        self.ParentType.valueChanges.pipe(takeUntil(self._subRelease)).subscribe(function (item) {
            var toRequire;
            toRequire = item && item.RequiresNote === true;
            var ctrl = self.proxyForm.get('ParentTypeNote');
            if (ctrl) {
                if (toRequire) {
                    ctrl.enable();
                    ctrl.setValidators(Validators.required);
                }
                else {
                    ctrl.disable();
                    ctrl.clearValidators();
                }
                ctrl.updateValueAndValidity({ emitEvent: false });
            }
        });
    };
    ProxyApproveDialogComponent.prototype.CancelHandler = function () {
        this.dialogRef.close(null);
    };
    ProxyApproveDialogComponent.prototype.OKHandler = function () {
        var self = this;
        var Proxy = self.proxyForm.value;
        self.dialogRef.close({
            ProxyParentName: Proxy.ParentName,
            ProxyRelationship: Proxy.ParentType != null ? Proxy.ParentType.ID : null,
            ProxyDescription: Proxy.ParentTypeNote,
        });
    };
    return ProxyApproveDialogComponent;
}());
export { ProxyApproveDialogComponent };
// #region Custom Classes
var BaseProxyApproveDialogOptions = /** @class */ (function () {
    function BaseProxyApproveDialogOptions() {
    }
    return BaseProxyApproveDialogOptions;
}());
export { BaseProxyApproveDialogOptions };
// #endregion



// WEBPACK FOOTER //
// ./src/services/dialogs/proxyapprove/proxyapprove.dialogcomponent.ts.pre-build-optimizer.js